import { LOADING_STATUS } from '../../main/support/constants';
import { INIT_WRAPPER_STATE } from '../constants/ReduxAsyncActions.constants';
import type { ActionNamespaceConstants, WrappedReducer, WrapperOptions } from '../types/ReduxAsyncActions.types';

export class ReduxAsyncActionsService {
  public static wrapReducer<StateType extends Record<string, any>, ActionType extends Record<string, any>>(
    initState: StateType,
    handler: (state: WrappedReducer<StateType>, action: ActionType) => WrappedReducer<StateType>,
    options: WrapperOptions
  ): (state: WrappedReducer<StateType> | undefined, action: ActionType) => WrappedReducer<StateType> {
    return function (state: WrappedReducer<StateType> | undefined, action: ActionType) {
      if (!state) {
        state = { ...initState, ...INIT_WRAPPER_STATE };
      }

      if (options) {
        if (options.request && options.request.length) {
          for (const action_group of options.request) {
            // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
            if (action_group.request == action.type) {
              return { ...state, loadingStatus: LOADING_STATUS.LOADING, loading: true, error: null };
            }
          }
        }

        if (options.error && options.error.length) {
          for (const action_group of options.error) {
            // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
            if (action_group.error == action.type) {
              return { ...state, loadingStatus: LOADING_STATUS.ERROR, loading: false, error: action.error };
            }
          }
        }

        if (options.resetOn) {
          for (const reset_action_type of options.resetOn) {
            // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
            if (reset_action_type == action.type) {
              return { ...initState, ...INIT_WRAPPER_STATE };
            }
          }
        }
      }

      return handler(state, action);
    };
  }

  public static generateAsyncActionConstants<ActionNamespace extends string>(
    actionNamespace: ActionNamespace
  ): ActionNamespaceConstants<ActionNamespace> {
    const upperCaseActionNamespace = actionNamespace.toUpperCase() as Uppercase<ActionNamespace>;
    return {
      request: `${upperCaseActionNamespace}_REQUEST`,
      response: `${upperCaseActionNamespace}_RESPONSE`,
      error: `${upperCaseActionNamespace}_ERROR`,
    };
  }
}
